module.exports = __webpack_public_path__ + "img/defender-robot.2974d198.png";